// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"598d18ec","725":"3c4965b4","774":"4e194e82","850":"65f30881"}[chunkId] + ".chunk.css";
};